import config from "@/config/config";
import { headers } from "./auth.headers";
import { formatQueryString } from "@/helpers/query-string";
import { ProductType } from "@/domain/product-type.model";
import { IPaginateVueTable } from "@/interfaces/IPaginateVueTable";
import httpClient from "@/helpers/http-client";

export default class ProductTypeService {
  private static urlApiBase = config.url_api_base;

  static insert = (data: ProductType): Promise<ProductType> => {
    return httpClient
      .request<ProductType>({
        url: `${this.urlApiBase}/product-type`,
        method: "POST",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static update = (data: ProductType): Promise<ProductType> => {
    return httpClient
      .request<ProductType>({
        url: `${this.urlApiBase}/product-type/${data.id}`,
        method: "PATCH",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static get = (id: string): Promise<ProductType> => {
    const url = `${this.urlApiBase}/product-type/${id}`;

    return httpClient
      .request<ProductType>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static list = (
    offset?: number,
    limit?: number,
    order?: string,
    sort?: string,
    filter?: string,
  ): Promise<IPaginateVueTable<ProductType>> => {
    const query = formatQueryString(offset, limit, order, sort, filter);
    const url = `${this.urlApiBase}/product-type${query}`;

    return httpClient
      .request<IPaginateVueTable<ProductType>>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static listActive = (): Promise<ProductType[]> => {
    const url = `${this.urlApiBase}/product-type/list-active`;

    return httpClient
      .request<ProductType[]>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static delete = (id: string): Promise<ProductType> => {
    const url = `${this.urlApiBase}/product-type/${id}`;

    return httpClient
      .request<ProductType>({
        url,
        method: "DELETE",
        headers: headers(),
      })
      .then(result => result?.body);
  };
}
